var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn px-md-5 px-3 py-2 py-md-3 text-nowrap",class:'btn-'+_vm.color,attrs:{"type":_vm.type,"size":_vm.size},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }